import {
    HANDLE_SURVEY_GROUP_QUESTION_REQUEST_CLOSE,
    HIDE_SURVEY_GROUP_QUESTION_LOADER,
    SHOW_SURVEY_GROUP_QUESTION_LOADER,
    ON_ADD_SURVEY_GROUP_QUESTION,
    ON_SAVE_SURVEY_GROUP_QUESTION,
    ON_SURVEY_GROUP_QUESTION_CLOSE,
    ON_DELETE_SURVEY_GROUP_QUESTION,
    ON_TOGGLE_SURVEY_GROUP_QUESTION_DRAWER,
} from 'constants/ActionTypes';


export const onAddSurveyGroupQuestion = () => {
    return {
        type: ON_ADD_SURVEY_GROUP_QUESTION,
        payload: ''
    };
};
export const onSurveyGroupQuestionClose = () => {
    return {
        type: ON_SURVEY_GROUP_QUESTION_CLOSE,
        payload: ''
    };
};
export const onSaveSurveyGroupQuestion = (data) => {
    return {
        type: ON_SAVE_SURVEY_GROUP_QUESTION,
        payload: data
    };
};
export const onDeleteSurveyGroupQuestion = (data) => {
    return {
        type: ON_DELETE_SURVEY_GROUP_QUESTION,
        payload: data
    };
};
export const onToggleSurveyGroupQuestionDrawer = () => {
    return {
        type: ON_TOGGLE_SURVEY_GROUP_QUESTION_DRAWER,
    };
};
export const handleSurveyGroupQuestionRequestClose = () => {
    return {
        type: HANDLE_SURVEY_GROUP_QUESTION_REQUEST_CLOSE,
    };
};
export const showSurveyGroupQuestionLoader = () => {
    return {
        type: SHOW_SURVEY_GROUP_QUESTION_LOADER,
    };
};
export const hideSurveyGroupQuestionLoader = () => {
    return {
        type: HIDE_SURVEY_GROUP_QUESTION_LOADER,
    };
};



// WEBPACK FOOTER //
// ./actions/SurveyGroupQuestion.js